import { useLoading as loading } from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css';

export const useLoading = () => {
    const $loading = loading({

    });
    let loader: any = null;
    const show = () => {
        loader = $loading.show();
    }
    return {
        show,
        hide() {
            if (!loader) return;
            const l = loader;
            loader = null;
            // Defer để tránh gọi hide() khi đang trong Vue teardown (gây lỗi _vnode)
            setTimeout(() => {
                try {
                    l.hide();
                } catch {
                    // Bỏ qua khi component đã unmount
                }
            }, 0);
        }
    }
}